import { InterviewTypeDto } from '../../services/bpp.webapi/client';

export class InterviewTypesState {
    list: InterviewTypeDto[];

    constructor() {
        this.list = [];
    }
}
